import { useQuery } from "@tanstack/react-query";
import { getRecentRegistrations } from "../openapi/api-client.ts";

export const useRecentRegistrations = () =>
  useQuery({
    queryKey: ["registrations", "recent"],
    queryFn: async () => {
      const response = await getRecentRegistrations();

      if (!response.data) {
        throw new Error(
          `error while fetching recent registrations: ${response.error.message}`,
        );
      }

      return response.data;
    },
    refetchInterval: 5000,
  });
